import React from 'react';
import { CardImage } from '@blueprint/card';
import { Image } from 'graphql.generated';
import ImagePlaceholder from 'public/assets/image-placeholder.svg';

import { getListingImage } from '..';
import {
    CardImagePlaceholder,
    ListingFlag,
    ListingImageCount,
    PropertyImage
} from './ListingImage.styles';
import { CameraMinifillSmall } from '@blueprint/icons';

type ListingImageProps = {
    count?: number | null | undefined;
    image?: Image | null | undefined;
    flag?: string | null | undefined;
    sizes?: string;
};

const ListingImage = ({
    count,
    image,
    flag,
    sizes = '17.5rem'
}: ListingImageProps) => {
    const listingImage = getListingImage(image);
    const hasImage = Boolean(listingImage.src);

    return (
        <PropertyImage>
            {flag && <ListingFlag>{flag}</ListingFlag>}

            {hasImage && (
                <>
                    <CardImage
                        sizes={sizes}
                        src={listingImage.src}
                        responsiveImgList={listingImage.responsiveImgList}
                        alt={`Listing photo${
                            listingImage.alt ? ` - ${listingImage.alt}` : ''
                        }`}
                    />
                    {count && (
                        <ListingImageCount>
                            <CameraMinifillSmall />
                            {count}
                        </ListingImageCount>
                    )}
                </>
            )}

            {!hasImage && (
                <CardImagePlaceholder>
                    <img
                        width="90"
                        src={ImagePlaceholder}
                        role="presentation"
                    />
                </CardImagePlaceholder>
            )}
        </PropertyImage>
    );
};

export default ListingImage;
export { PropertyImage, CardImagePlaceholder };
